import React from 'react';
import { BarChart3, TrendingUp, Users, FileText, Download, Upload } from 'lucide-react';

const Statistics = () => {
  const stats = [
    {
      title: 'Total de Usuarios',
      value: '2,847',
      change: '+12%',
      icon: Users,
      color: 'from-blue-500 to-cyan-500'
    },
    {
      title: 'Documentos Procesados',
      value: '45,892',
      change: '+23%',
      icon: FileText,
      color: 'from-emerald-500 to-green-500'
    },
    {
      title: 'Descargas Totales',
      value: '28,451',
      change: '+8%',
      icon: Download,
      color: 'from-purple-500 to-pink-500'
    },
    {
      title: 'Subidas Este Mes',
      value: '3,784',
      change: '+15%',
      icon: Upload,
      color: 'from-amber-500 to-orange-500'
    }
  ];

  const popularTools = [
    { name: 'Comprimir PDF', usage: 45, growth: 12 },
    { name: 'Unir PDF', usage: 32, growth: 8 },
    { name: 'Word a PDF', usage: 28, growth: 15 },
    { name: 'Firma Digital', usage: 25, growth: 23 },
    { name: 'Dividir PDF', usage: 18, growth: 5 }
  ];

  const recentActivity = [
    { time: 'Hoy', documents: 1243, users: 892 },
    { time: 'Ayer', documents: 987, users: 756 },
    { time: 'Esta Semana', documents: 5241, users: 2341 },
    { time: 'Este Mes', documents: 18942, users: 2847 }
  ];

  return (
    <div className="p-6 space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Estadísticas</h1>
          <p className="text-slate-600">Métricas y análisis de uso de la plataforma</p>
        </div>
        <div className="w-10 h-10 bg-gradient-to-br from-red-500 to-rose-500 rounded-xl flex items-center justify-center">
          <BarChart3 className="w-5 h-5 text-white" />
        </div>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {stats.map((stat, index) => {
          const Icon = stat.icon;
          return (
            <div key={index} className="bg-white rounded-2xl p-6 shadow-lg border border-slate-200">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-slate-600">{stat.title}</p>
                  <p className="text-2xl font-bold text-slate-900 mt-1">{stat.value}</p>
                  <div className="flex items-center mt-2">
                    <TrendingUp className="w-4 h-4 text-emerald-500 mr-1" />
                    <span className="text-sm font-medium text-emerald-600">{stat.change}</span>
                    <span className="text-sm text-slate-500 ml-1">vs mes anterior</span>
                  </div>
                </div>
                <div className={`w-12 h-12 bg-gradient-to-br ${stat.color} rounded-xl flex items-center justify-center shadow-md`}>
                  <Icon className="w-6 h-6 text-white" />
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Herramientas Populares */}
        <div className="bg-white rounded-2xl p-6 shadow-lg border border-slate-200">
          <h3 className="text-lg font-semibold text-slate-900 mb-6">Herramientas Más Usadas</h3>
          <div className="space-y-4">
            {popularTools.map((tool, index) => (
              <div key={tool.name} className="flex items-center justify-between">
                <div className="flex items-center space-x-3">
                  <div className="w-8 h-8 bg-gradient-to-br from-red-500 to-rose-500 rounded-lg flex items-center justify-center">
                    <FileText className="w-4 h-4 text-white" />
                  </div>
                  <div>
                    <p className="font-medium text-slate-900">{tool.name}</p>
                    <p className="text-sm text-slate-500">{tool.usage}% de uso</p>
                  </div>
                </div>
                <div className="flex items-center space-x-2">
                  <TrendingUp className="w-4 h-4 text-emerald-500" />
                  <span className="text-sm font-medium text-emerald-600">+{tool.growth}%</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Actividad Reciente */}
        <div className="bg-white rounded-2xl p-6 shadow-lg border border-slate-200">
          <h3 className="text-lg font-semibold text-slate-900 mb-6">Resumen de Actividad</h3>
          <div className="space-y-4">
            {recentActivity.map((activity, index) => (
              <div key={index} className="flex items-center justify-between p-3 rounded-xl hover:bg-slate-50 transition-colors">
                <div>
                  <p className="font-medium text-slate-900">{activity.time}</p>
                  <div className="flex space-x-4 mt-1">
                    <div className="text-sm text-slate-600">
                      <span className="font-medium">{activity.documents}</span> documentos
                    </div>
                    <div className="text-sm text-slate-600">
                      <span className="font-medium">{activity.users}</span> usuarios
                    </div>
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-sm font-medium text-emerald-600">
                    +{Math.round((activity.documents / activity.users) * 100) / 100}
                  </div>
                  <div className="text-xs text-slate-500">doc/user</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Statistics;